import { VERSION_STATUS, VersionStatus, Visibility, VISIBILITY } from '@hashnode/database-schema'
import { z } from 'zod'

export const visibilitySchema = z
	.optional(z.enum(VISIBILITY))
	.nullable()
	.or(
		z.string().transform((val, ctx) => {
			const upperVal = val.toUpperCase()
			if (VISIBILITY.includes(upperVal as Visibility)) {
				return upperVal as Visibility
			}
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: `Invalid visibility value: ${val}`,
			})
			return z.NEVER
		}),
	)

export const guideVersionStatusSchema = z.enum(VERSION_STATUS).or(
	z.string().transform((val, ctx) => {
		const upperVal = val.toUpperCase()
		if (VERSION_STATUS.includes(upperVal as VersionStatus)) {
			return upperVal as VersionStatus
		}
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: `Invalid version status: ${val}`,
		})
		return z.NEVER
	}),
)

// SEO Schema
export const seoSchema = z.object({
	title: z.string(),
	description: z.string(),
})

export const guideLevelSettingsSchema = z.object({
	name: z.string(),
	slug: z.string(),
	seo: z.optional(seoSchema),
})

export const versionLevelSettingsSchema = z.object({
	name: z.string(),
	slug: z.string(),
	codeName: z.optional(z.string()),
	isDefault: z.optional(z.boolean()).default(false),
	status: z.optional(guideVersionStatusSchema).default('STABLE'),
	visibility: visibilitySchema,
})

export type ParsedSEOConfig = z.infer<typeof seoSchema>
export type ParsedGuideSettingsConfig = z.infer<typeof guideLevelSettingsSchema>
export type ParsedVersionSettingsConfig = z.infer<typeof versionLevelSettingsSchema>
